/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Phred score converter. Turn a Phred quality score (Q) into its error probability, base-call accuracy and Phred+33 / Phred+64 ASCII characters, or convert an error probability back to Q.`)
};

const es_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de puntuación Phred. Convierte una puntuación de calidad Phred (Q) en su probabilidad de error, precisión de llamada de base y caracteres ASCII Phred+33 / Phred+64, o convierte una probabilidad de error de vuelta a Q.`)
};

const de_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Phred-Score-Konverter. Wandeln Sie einen Phred-Qualitätswert (Q) in seine Fehlerwahrscheinlichkeit, Basenaufruf-Genauigkeit und Phred+33-/Phred+64-ASCII-Zeichen um, oder konvertieren Sie eine Fehlerwahrscheinlichkeit zurück in Q.`)
};

const nl_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Phred-scoreconverter. Zet een Phred-kwaliteitsscore (Q) om naar de foutkans bij basecalling, nauwkeurigheid en Phred+33-/Phred+64-ASCII-tekens, of zet een foutkans terug om naar een Q-score.`)
};

const fr_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur gratuit de score Phred. Transformez un score de qualité Phred (Q) en probabilité d'erreur, précision d'appel de base et caractères ASCII Phred+33 / Phred+64, ou convertissez une probabilité d'erreur en score Q.`)
};

const it_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore gratuito di punteggi Phred. Trasforma un punteggio di qualità Phred (Q) nella sua probabilità di errore, accuratezza del base-calling e caratteri ASCII Phred+33 / Phred+64, oppure converti una probabilità di errore in Q.`)
};

const pt_br2_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de escore Phred. Transforme um escore de qualidade Phred (Q) em sua probabilidade de erro na chamada de base, precisão e caracteres ASCII Phred+33 / Phred+64, ou converta uma probabilidade de erro de volta em Q.`)
};

const pt_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de pontuação Phred. Transforme uma pontuação de qualidade Phred (Q) na sua probabilidade de erro, precisão de chamada de base e caracteres ASCII Phred+33 / Phred+64, ou converta uma probabilidade de erro de volta para Q.`)
};

const ja_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のPhredスコア変換ツール。Phred品質スコア (Q) をエラー確率、塩基コール精度、Phred+33 / Phred+64のASCII文字に変換、またはエラー確率からQに逆変換します。`)
};

const zh_phred_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 Phred 分数转换器。将 Phred 质量分数（Q）转换为错误概率、碱基判读准确率以及 Phred+33 / Phred+64 ASCII 字符，也可将错误概率反向转换为 Q。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_meta_description", locale)
	if (locale === "en") return en_phred_meta_description(inputs)
	if (locale === "es") return es_phred_meta_description(inputs)
	if (locale === "de") return de_phred_meta_description(inputs)
	if (locale === "nl") return nl_phred_meta_description(inputs)
	if (locale === "fr") return fr_phred_meta_description(inputs)
	if (locale === "it") return it_phred_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_phred_meta_description(inputs)
	if (locale === "pt") return pt_phred_meta_description(inputs)
	if (locale === "ja") return ja_phred_meta_description(inputs)
	return zh_phred_meta_description(inputs)
};